export default class {
    [x: string]: any;
    getFullName(user) {
        // TODO: find the root cause of the problem
        if (!user) return
        return user.name ? `${user.name} ${user.surname}` : user.username;
    }

    isActive(user) {
        // TODO: find the root cause of the problem
        if (!user) return
        return user.state === 'ACTIVE';
    }
}
